import { NavigationError } from '@angular/router';

const LAST_RELOAD_KEY = 'renco.lastReloadForMissingCode';
/** Long enough to cover the navigations right after a reload, short enough for the next deploy. */
const QUIET_PERIOD_MS = 30_000;

/**
 * After a new deploy the files of the previous version are gone. Someone who still has the old version open and
 * goes to another page asks for a file that no longer exists, and the navigation fails without a word. The site
 * then loads that page anew: the new version comes along. If the file is still missing after that, it does not
 * try again for a while, so it never keeps reloading.
 */
export function reloadWhenThePageCodeIsGone(error: NavigationError): void {
  if (!isMissingPageCode(error.error)) {
    return;
  }

  try {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);

    if (Date.now() - lastReload < QUIET_PERIOD_MS) {
      return;
    }

    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    // Without session storage there is no guard against a loop, so no reload either.
    return;
  }

  window.location.assign(error.url);
}

/** The ways Chrome, Firefox and Safari say that a lazily loaded file could not be fetched. */
function isMissingPageCode(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);

  return /dynamically imported module|Importing a module script failed|Loading chunk/i.test(message);
}
